import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import MenuSection from "@/components/MenuSection";
import SpecialsSection from "@/components/SpecialsSection";
import LocationSection from "@/components/LocationSection";
import GalleryStrip from "@/components/GalleryStrip";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-disco-void min-h-screen overflow-x-clip">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <MenuSection />
      <SpecialsSection />

      <LocationSection />
      <GalleryStrip />
      <ContactSection />
      <Footer />
    </div>
  );
}
